import { Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';
import { firmGuard } from './auth/guards/firm.guard';
import { permissionGuard } from './auth/guards/permission.guard';

/**
 * Routes for the HashBooks Accountant firm workspace.
 *
 * `/auth/*` — sign in / sign up (lazy, public).
 * `/app/*`  — the authenticated shell (sidebar + top bar) with one child per area.
 */
export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES)
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/shell/shell.layout').then((m) => m.ShellLayout),
    children: [
      { path: 'dashboard', loadComponent: () => import('./features/dashboard/dashboard.page').then((m) => m.DashboardPage) },
      { path: 'clients', loadComponent: () => import('./features/clients/clients.page').then((m) => m.ClientsPage) },
      { path: 'clients/:id', loadComponent: () => import('./features/clients/client-review.page').then((m) => m.ClientReviewPage) },
      { path: 'requests', canActivate: [permissionGuard('clients.manage')], loadComponent: () => import('./features/requests/requests.page').then((m) => m.RequestsPage) },
      { path: 'team', canActivate: [firmGuard, permissionGuard('team.manage')], loadComponent: () => import('./features/team/team.page').then((m) => m.TeamPage) },
      { path: 'roles', canActivate: [firmGuard, permissionGuard('team.manage')], loadComponent: () => import('./features/roles/roles.page').then((m) => m.RolesPage) },
      { path: 'billing', canActivate: [permissionGuard('billing.manage')], loadComponent: () => import('./features/billing/billing.page').then((m) => m.BillingPage) },
      { path: 'settings', loadComponent: () => import('./features/settings/settings.page').then((m) => m.SettingsPage) },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' }
    ]
  },
  { path: '', pathMatch: 'full', redirectTo: 'app/dashboard' },
  { path: '**', redirectTo: 'app/dashboard' }
];
